/*
 * @Author: your name
 * @Date: 2022-02-24 17:25:04
 * @LastEditTime: 2022-07-07 14:57:54
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jeecg-boot\ant-design-vue-jeecg\src\utils\oss\oss_service.ts
 */

import axios from 'axios'
import { gzip } from 'pako'
let ossPrefix = 'http://designorder.oss-cn-shanghai.aliyuncs.com/'

// 缓存
// 缓存空间200M
// 缓存事件1mim
// const lruCache = new LRU({ max: 200 * 1024 * 1024, maxAge: 1000 * 60 })

export enum EN_BUSINESS_CODE {
  INVALID = '',
  // 项目文件
  PROJECT_FILE = 'project',
  // 组织文件
  GROUP_FILE = 'group',
  // 模型树文件
  MODEL_TREE_FILE = 'designFileSolutionFile',
}

export enum EN_CAD_RESOURCE_TYPE {
  TEMPLATE = 'template',
  FRAME = 'frame',
}

export interface IOSSFile {
  fileId: number
  fileSize: number
  fileSHA1: string
  fileAddress: string
  fileName: string
}

/** 设置OSS请求前缀 */
export function setOSSPrefix(prefix: string): void {
  ossPrefix = prefix
}

class OssServiceImpl {
  /**
   * 获取OSS文件内容
   * @param OSSPath OSS文件路径 如: DO-Design_Dev/webfiles/a363cb20-34d7-481b-804e-e9d9005379f2-data(4).stl
   * @returns 文件内容
   */
  public async downloadFromOSS<T = string>(OSSPath: string, options = {}): Promise<T> {
    // if (lruCache.has(OSSPath)) {
    //     return lruCache.get(OSSPath) as T;
    // }

    const url = `${window.ENV_CONFIG.ossPrefix}${OSSPath}`
    const { data: response } = await axios.get<T>(url, options)
    return response
  }

  /**
   * 下载指定文件
   */
  public downloadFileFromOss(OSSPath: string): void {
    const url = `${window.ENV_CONFIG.ossPrefix}${OSSPath}`
    window.open(url)
  }

  /**
   * 上传内容至OSS
   * @param uploadUrl OSS上传路径
   * @param file 文件内容
   * @param opts 定制化headers
   * @returns
   */
  public async uploadToOSS(uploadUrl: string, file: Uint8Array | string, opts?: any): Promise<boolean | Error> {
    const compressedFile = gzip(file)
    const headers = { 'content-type': 'application/octet-stream', 'content-encoding': 'gzip' }
    Object.assign(headers, opts)
    const data = await axios
      .put(uploadUrl, compressedFile, {
        headers,
      })
      .catch(() => {
        throw new Error('上传失败')
      })
    console.log(data)
    return true
  }
  // -----------------------------------------------------------------------
}

export const OssService = new OssServiceImpl()
